module.exports = __webpack_public_path__ + "static/media/bg-pattern-intro-right-mobile.ef3d23bd.svg";